import { ALT_SUREC_VE_DURUMUNA_GORE_BASVURU_LISTESI } from "../constants/requestUrls";
import { postRequest } from "../request";

const altSurecVeDurumaGoreBasvuruListesi = (props) => {
  
    let data = {};
    if (props !== undefined)
      data = JSON.stringify(props);
  
    return postRequest({url:ALT_SUREC_VE_DURUMUNA_GORE_BASVURU_LISTESI,data});
}

export default altSurecVeDurumaGoreBasvuruListesi;